type BedState = {
  anyOrStudio: boolean;
  oneOrMore: boolean;
  twoOrMore: boolean;
  threeOrMore: boolean;
  fourOrMore: boolean;
  isExact: boolean;
};

/**
 * Determines whether the Apply button should be shown in the bedroom filter
 *
 * Business Rules:
 * - Show Apply button when user has made a meaningful selection that needs to be applied
 * - Hide Apply button when in default state (anyOrStudio selected with isExact=false)
 *   because this represents "no filter" and doesn't require explicit application
 *
 * Logic:
 * - ALWAYS show when isExact is true (user wants exact match behavior)
 * - Show when isExact is false AND anyOrStudio is NOT selected (user selected specific bedroom count)
 * - Hide ONLY when isExact is false AND anyOrStudio is true (default "any" state)
 *
 * @param bedState - Current bedroom filter state
 * @returns true if Apply button should be visible, false otherwise
 *
 * @example
 * // Default state - no Apply button needed
 * shouldShowBedroomApplyButton({ anyOrStudio: true, oneOrMore: false, ..., isExact: false })
 * // Returns: false
 *
 * @example
 * // User selected specific bedroom count - needs Apply
 * shouldShowBedroomApplyButton({ anyOrStudio: false, twoOrMore: true, ..., isExact: false })
 * // Returns: true
 *
 * @example
 * // User enabled exact matching - needs Apply
 * shouldShowBedroomApplyButton({ anyOrStudio: true, oneOrMore: false, ..., isExact: true })
 * // Returns: true
 */
export const shouldShowBedroomApplyButton = (bedState: BedState): boolean => {
  return (bedState.isExact === false && bedState.anyOrStudio !== true) || bedState.isExact === true;
};
